export default __webpack_public_path__ + "static/media/tip.d8644b87.svg";